import { render, staticRenderFns } from "./OldMutualFooterRedesign.vue?vue&type=template&id=53e75e92&scoped=true"
import script from "./OldMutualFooterRedesign.vue?vue&type=script&lang=js"
export * from "./OldMutualFooterRedesign.vue?vue&type=script&lang=js"
import style0 from "./OldMutualFooterRedesign.vue?vue&type=style&index=0&id=53e75e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e75e92",
  null
  
)

export default component.exports